import {
  ComponentRef,
  Directive,
  ElementRef,
  EmbeddedViewRef,
  HostListener,
  Input, Renderer2,
  ViewContainerRef
} from '@angular/core';
import {TooltipComponent} from "./tooltip.component";
import {TooltipPosition, TooltipTheme} from "./tooltip.enums";
import {Lookups} from "@model";

@Directive({
    selector: '[app-tooltip]',
    standalone: false
})
export class TooltipDirective {

  @Input({required: true}) languages: Lookups[] = [];
  @Input() tooltip: { hr?: string, en?: string, it?: string, slo?: string, sr?:string, bs?:string } = {hr: ''};
  @Input() position: TooltipPosition = TooltipPosition.DEFAULT;
  @Input() theme: TooltipTheme = TooltipTheme.DEFAULT;
  @Input() showDelay = 0;
  @Input() hideDelay = 0;

  private componentRef: ComponentRef<any> | null = null;
  private tooltipHolder: HTMLElement;

  constructor(private elementRef: ElementRef,
              private viewContainerRef: ViewContainerRef, private renderer: Renderer2) {
    this.tooltipHolder = elementRef.nativeElement;
  }

  ngOnInit() {
    this.tooltipHolder = this.elementRef.nativeElement.querySelector("#tooltipTarget") ?? this.elementRef.nativeElement
  }

  @HostListener('mouseenter')
  onMouseEnter(): void {
    this.initializeTooltip();
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.setHideTooltipTimeout();
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    this.setHideTooltipTimeout();
  }


  private initializeTooltip() {
    if (this.componentRef === null) {
      this.componentRef = this.viewContainerRef.createComponent(TooltipComponent);
      const [tooltipDOMElement] = (this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes;
      this.setTooltipComponentProperties();
      this.renderer.appendChild(this.tooltipHolder, tooltipDOMElement);
      setTimeout(() => {
        this.showTooltip();
      }, this.showDelay);
    }
  }

  private setTooltipComponentProperties() {
    if (this.componentRef !== null) {

      this.componentRef.instance.hrLabel = this.tooltip.hr;
      this.componentRef.instance.enLabel = this.tooltip.en;
      this.componentRef.instance.itLabel = this.tooltip.it;
      this.componentRef.instance.siLabel = this.tooltip.slo;
      this.componentRef.instance.srLabel = this.tooltip.sr;
      this.componentRef.instance.bsLabel = this.tooltip.bs;
      this.componentRef.instance.languages = this.languages;
      this.componentRef.instance.position = this.position;
      this.componentRef.instance.theme = this.theme;

      const {left, right, top, bottom} = this.tooltipHolder.getBoundingClientRect();

      switch (this.position) {
        case TooltipPosition.RIGHT_TOP: {
          this.componentRef.instance.left = Math.round(right);
          this.componentRef.instance.top = Math.round(top);
          break;
        }
        default: {
          break;
        }
      }
    }
  }

  private showTooltip() {
    if (this.componentRef !== null) {
      this.componentRef.instance.visible = true;
    }
  }

  private setHideTooltipTimeout() {
    setTimeout(() => {
      this.destroy();
    }, this.hideDelay);
  }

  ngOnDestroy(): void {
    this.destroy();
  }

  destroy(): void {
    if (this.componentRef !== null) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
  }
}
